export const GROUP_COL = {
  label: "专车直达",
  value: 18,
  type: "chartered_bus",
};
